/**
 * @author       Lordd Michael Lazaro <lorddlazaro.taktyl@gmail.com>
 */

import { ScaleManager } from "../managers/ScaleManager";
import { GameManager } from "../managers/GameManager";

export abstract class Scene extends Phaser.Scene{

    scaleManager:ScaleManager = (<ScaleManager>ScaleManager.instance);
    gameManager:GameManager = (<GameManager>GameManager.instance);

    previousOrientationLandscape:boolean|null = null;
    hasCreated:boolean = false;

    create(){
        console.log('Creating Scene:'+this.scene.settings.key);
        this.prescaleCreate();
        console.log('Prescale Created:'+this.scene.settings.key);
        this.events.on('resize',this.preReorient,this);
        this.scaleManager.rescale();
        this.hasCreated = true;
    }

    abstract prescaleCreate();
    abstract reorient(landscape:boolean);

    preReorient(){
        
        if(this.scaleManager.isOrientationLandscape() != this.previousOrientationLandscape || this.previousOrientationLandscape == null){
            this.previousOrientationLandscape = this.scaleManager.isOrientationLandscape();
            // if(this.hasCreated == false)
            //     this.previousOrientationLandscape = null;{
            // }
            if(this.scaleManager.isOrientationLandscape()){
                console.log('Reorienting Scene:'+this.scene.settings.key+ " Orientation: Landscape");
                this.reorient(true);
            }else{
                console.log('Reorienting Scene:'+this.scene.settings.key+ " Orientation: Portrait");
                this.reorient(false);
            }
        }
    }

}